<template>
    <v-expansion-panel-content :hide-actions="!hasEventRecords" :disabled="!hasEventRecords">
      <template v-slot:header>
        <v-layout>
          <div class="subheading">
            <span v-if="log._source.IsTestRun" class="info--text">[TEST RUN]</span>
            <span v-else-if="log._source.IsCheckFileFormat" class="info--text">[VALIDATION]</span>
            <span v-else-if="log._source.IsRollback" class="error--text">[ROLLBACK]</span>
            <span class="grey--text text--lighten-1">{{ executionDate }} · {{log._source.FileName}} -</span> {{log._source.ExecutionOutcome}}
          </div>
          <v-spacer />
          <div class="mr-2 d-flex align-center">
            <v-icon :color="getInfoLogsColor(log)">done</v-icon>
            <span class="log-message-count">{{infoFormatCount(getInfoCount(log))}}</span>
          </div>
          <div class="mr-2 d-flex align-center">
            <v-icon :color="getWarningLogsColor(log)">warning</v-icon>
            <span class="log-message-count">{{formatCount(getWarnCount(log))}}</span>
          </div>
          <div class="mr-2 d-flex align-center">
            <v-icon :color="getErrorLogsColor(log)">error</v-icon>
            <span class="log-message-count">{{formatCount(getErrorCount(log))}}</span>
          </div>
        </v-layout>
        <InnerDetailDialog :detailedEvent="detailedEvent" ref="dialog" />
      </template>
      <VirtualList :size="40" :remain="6">
        <v-card v-for="(eventRecord, j) in parsedEventRecords" :key="j">
          <v-expansion-panel-content :disabled="!eventRecord.details" class="inner-event-log" :class="{stripe: j%2==0}">
            <template v-slot:header>
              <template v-if="eventRecord.MaxLevel !== null">
                <div v-if="eventRecord.MaxLevel === logTypes.info.value" class="flex-grow-0 mr-2">
                  <v-icon color="light-green">done</v-icon>
                </div>
                <div v-else-if="eventRecord.MaxLevel === logTypes.warn.value" class="flex-grow-0 mr-2">
                  <v-icon color="yellow">warning</v-icon>
                </div>
                <div v-else-if="eventRecord.MaxLevel === logTypes.error.value" class="flex-grow-0 mr-2">
                  <v-icon color="red">error</v-icon>
                </div>
              </template>
              <span>{{ eventRecord.Message[0]}}</span>
            </template>
            <v-card v-if="eventRecord.details">
              <table class="inner-nested-event-log max-width text-xs-left" cellspacing="10" :class="{stripe: j%2==0}">
                <col width="10%" />
                <col width="50%" />
                <col width="20%" />
                <tr>
                  <template v-for="(key, k) in Object.keys(eventRecord)">
                    <th :key="k" v-if="key!='color'" class>{{ splitByCapitalLetter(key) }}</th>
                  </template>
                </tr>
                <tr :class="eventRecord.color[0]+'--text'">
                  <td>{{eventRecord.EventLevel[0]}}</td>
                  <td>{{eventRecord.Message[0]}}</td>
                </tr>
                <template v-if="eventRecord.details && eventRecord.details.length > 0">
                  <tr v-for="(record, l) in eventRecord.details" :key="l" :class="record.color+'--text'">
                    <td>{{record.EventLevel}}</td>
                    <td>{{record.Message}}</td>
                    <td v-if="Object.keys(record).length > 3">
                      <v-btn small text light @click="setDetailedEventRecord(record, log._source.ProcessInstanceId)">{{$t('Button.ViewDetails')}}</v-btn>
                    </td>
                  </tr>
                </template>
                <br />
              </table>
            </v-card>
          </v-expansion-panel-content>
        </v-card>
      </VirtualList>
    </v-expansion-panel-content>
</template>
<script>
  import { logTypes } from '@/helpers/serviceLogs'
  import virtualList from 'vue-virtual-scroll-list'
  import InnerDetailDialog from './InnerDetailDialog'
  import moment from 'moment'
  import { numberWithCommas } from '@/helpers/numbers'
  import { splitByCapitalLetter } from '@/helpers/strings'

  export default {
    components: {
      InnerDetailDialog,
      VirtualList: virtualList,
    },
    props: {
      log: Object,
    },
    data: () => ({
      logTypes,
      eventLevelStringToColorLookup: {
        [logTypes.info.value]: 'light-green',
        [logTypes.warn.value]: 'yellow',
        [logTypes.error.value]: 'red',
      },
      detailedEvent: [],
      alternativeColor: '#E0E0E0',
      parsedEventRecords: [],
    }),
    computed: {
      executionDate() {
        return moment(this.log._source.ExecutionDate).format('HH:mm:ss')
      },
      // test() {
      //   if (this.log === null) return []
      //   let parsedLogs = this.parseEventRecords(this.log, this.log._source.EventRecords)
      //   console.log('computedTest', parsedLogs)
      //   return parsedLogs
      // },
      hasEventRecords() {
        return !!this.log && !!this.log._source.EventRecords && this.log._source.EventRecords.length > 0
      },
    },
    watch: {
      log() {
        //this.setParsedEventRecords()
      },
    },
    mounted() {
      //this.setParsedEventRecords()
    },
    methods: {
      splitByCapitalLetter,
      makeMoment(date) {
        return moment(date)
      },
      infoFormatCount(count) {
        return count > 0 ? numberWithCommas(count) : 0
      },
      formatCount(count) {
        return count > 0 ? numberWithCommas(count) : 0
      },
      getInfoLogsColor(log) {
        let color = 'light-green'

        if (this.getInfoCount(log) == 0 &&
          (this.getWarnCount(log) > 0 || this.getErrorCount(log) > 0)
        ) {
          color = this.alternativeColor
        }

        return color
      },
      getWarningLogsColor(log) {
        return this.getWarnCount(log) > 0 ? 'yellow' : this.alternativeColor
      },
      getErrorLogsColor(log) {
        return this.getErrorCount(log) > 0 ? 'red' : this.alternativeColor
      },
      getInfoCount(log) {
        return log.Counts.Info
      },
      getWarnCount(log) {
        return log.Counts.Warn
      },
      getErrorCount(log) {
        return log.Counts.Error
      },
      setDetailedEventRecord(recordEvent, processInstanceId) {
        this.$refs.dialog.setDetailedEventRecord(recordEvent, processInstanceId)
      },
      parseEventRecords(log, eventRecords) {
        let results = []
        for (let idx in eventRecords) {
          let result = {}
          for (let key in eventRecords[idx]) {
            if (eventRecords[idx][key] == null) continue
            result = this.parseEventRecordKeys(
              key,
              eventRecords[idx][key],
              result,
              idx + '_' + key
            )
          }

          this.setMaxLevel(result)
          results.push(result)
        }

        this.countLogTypes(log, results)
        return Object.freeze(results)
      },
      countLogTypes(log, eventRecords) {
        let count = {
          [logTypes.info.value]: 0,
          [logTypes.warn.value]: 0,
          [logTypes.error.value]: 0,
        }

        eventRecords.forEach(eventRecord => {
          count[eventRecord.MaxLevel] += 1
        })

        log.Counts.Info = count[logTypes.info.value]
        log.Counts.Warn = count[logTypes.warn.value]
        log.Counts.Error = count[logTypes.error.value]
      },
      setMaxLevel(eventRecord) {
        let maxLevel = eventRecord.EventLevel[0]
        if (eventRecord.details && eventRecord.details.length) {
          for (let idx in eventRecord.details) {
            if (eventRecord.details[idx].EventLevel > maxLevel) {
              maxLevel = eventRecord.details[idx].EventLevel
            }
          }
        }

        eventRecord.MaxLevel = maxLevel
      },
      parseEventRecordKeys(key, value, result, id) {
        result.id = id
        if (key === 'EventLevel') {
          if (result[key] && result[key].length) {
            result[key].push(value)
          } else {
            result[key] = [value]
          }
          if (result.color && result.color.length) {
            result.color.push(this.eventLevelStringToColorLookup[value])
          } else {
            result.color = [this.eventLevelStringToColorLookup[value]]
          }

          return result
        }

        if (key === 'Message') {
          if (result[key] && result[key].length) {
            result[key].push(value)
          } else {
            result[key] = [value]
          }

          return result
        }

        if (key === 'InnerEventRecords') {
          result.details = value
          for (let innerRecord in result.details) {
            result.details[innerRecord].color =
              this.eventLevelStringToColorLookup[result.details[innerRecord].EventLevel]
          }

          return result
        }

        return result
      },
    },
  }
</script>

<style scoped>
  .stripe {
    background-color: #5c5c5c !important;
  }

  .layout {
    text-shadow: 0 0 2px black;
  }

  li.v-expansion-panel__container.inner-event-log {
    text-shadow: 0 0 2px black;
  }

  table.inner-nested-event-log {
    /* font-weight: bold; */
    /* text-shadow: 0 0 10px black; */
  }

  table {
    padding-left: 10%;
  }

  li.v-expansion-panel__container.v-expansion-panel__container--disabled {
    color: white !important;
    padding-right: 25px;
  }

  .log-message-count {
    padding-left: 5px;
    font-size: 1.25em;
  }
</style>
